import { BootstrapContext, DistUrl } from 'rev-shared/bootstrap/BootstrapContext';


export enum ResourceType {
	Video = 'video',
	Webcast = 'webcast'
}

function ensureEndsWithSlash(url: string): string {
	return url.endsWith('/') ? url : url + '/';
}

const baseCdnUrl = BootstrapContext.baseCdnUrl ? ensureEndsWithSlash(BootstrapContext.baseCdnUrl) : 'https://static-qa.vbricklab.com/';

export const C2PA_RESOURCE_CONFIG = {
	wasmSrc: `${ensureEndsWithSlash(DistUrl)}c2pa-assets/c2pa_bg.wasm`,
	trustAnchors: `${baseCdnUrl}c2pa/trust-list/C2PA-TRUST-LIST.pem`
};
